<template>
  <div class="brand-page" ref="gallery">
    <div class="topBar">
      <div class="subTitle"><i class="far fa-window-minimize" style="transform:rotate(90deg);margin-right: -5px;color:rgba(52,152,219,1);"></i>商品评价详情</div>
    </div>
    <div style="width: 1056px;margin: 0 auto;border:1px solid #ddd;margin-top:30px;">
      <div class="form-title">
        <div style="margin-left:30px;line-height:46px">评价信息</div>
      </div>
      <div style="height:16px;wiidth:100%;background:#fff"></div>
      <div class="table">
        <table class="tab_box">
          <tr class="tab_tr">
            <th class="tab_th">内容</th>
            <td class="tab_td">{{content}}</td>
          </tr>

          <tr class="tab_tr">
            <th class="tab_th">评分</th>
            <td class="tab_td" style="color: #f64e62;">{{rank}}</td>
          </tr>
          <tr class="tab_tr">
            <th class="tab_th">评论时间</th>
            <td class="tab_td">{{create_time}}</td>
          </tr>
          <tr class="tab_tr">
            <th class="tab_th">商品名称</th>
            <td class="tab_td">{{title}}</td>
          </tr>
          <tr class="tab_tr">
            <th class="tab_th">昵称</th>
            <td class="tab_td">{{nickname}}</td>
          </tr>
          <tr class="tab_tr">
            <th class="tab_th">分类</th>
            <td class="tab_td">{{classification}}</td>
          </tr>
          <tr class="tab_tr">
            <th class="tab_th">品牌</th>
            <td class="tab_td">{{brand}}</td>
          </tr>
          <tr class="tab_tr">
            <th class="tab_th">账号</th>
            <td class="tab_td">{{mobile}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
   

<script>
import $ from "jquery";
export default {
  name: "gallery",
  data() {
    return { serve: this.$store.state.serve,
      tableData: [],
      username: "",
      token: "",
      id: this.$route.params.id,
      content: "",
      rank: "",
      create_time: "",
      title: "",
      nickname: "",
      classification: "",
      brand: "",
      mobile: ""
    };
  },
  created() {
    this.$store.state.topActiveId = 2;
    this.$store.state.leftTitle = '商品评价'
    this.geting();
  },
  methods: {
    geting() {
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve+"/admin/comment_detail", {
          params: {
            username: this.username,
            token: this.token,
            id: this.id
          }
        })
        .then(res => {
          var json = res.data.data;
          if (res.data.status == "success") {
            for (var key in json) {
              this.content = json[key].content;
              this.rank = json[key].rank;
            
              this.title = json[key].title;
              this.nickname = json[key].nickname;
              this.classification = json[key].classification;
              this.brand = json[key].brand;
              this.mobile = json[key].mobile;
              var time = json[key].create_date;
              var timeNew = new Date(parseInt(time) * 1000)
                .toLocaleString()
                .replace(/:\d{1,2}$/, " ");
              this.create_time = timeNew;
            }
          }
        });
    }
  }
};
</script>

<style lang="scss">
.topBar {
  margin-bottom: 40px;
  .el-step__icon {
    height: 54px;
    width: 54px;
  }
  .subTitle {
    width: 1050px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
  }
  .rutun {
    width: 78px;
    height: 28px;
    background: #fff;
    border: 1px solid rgba(221, 221, 221, 1);
    text-align: center;
    margin-top: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }
  .rutun:hover {
    color: #0099ff;
  }
}
.table {
  background: #fff;
  padding-bottom: 30px;
  .tab_box {
    width: 97%;
    margin: 0 auto;
    margin-bottom: 16px;

    .tab_tr {
      width: 100%;
      height: 100%;
      border: 1px solid rgba(221, 221, 221, 1);
      .tab_th {
        padding: 0;
        margin: 0;
        width: 160px;
        height: 50px;
        background: rgba(245, 250, 249, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        font-size: 14px;
        text-align: right;
        padding-right: 40px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .tab_td {
        padding: 0;
        margin: 0;
        border: 1px solid rgba(221, 221, 221, 1);
        padding-left: 20px;
        font-size: 14px;

        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
    }
  }
}

.filtrate {
  width: 1060px;
  margin-left: 420px;
  // background: orange;

  .filtrate_head {
    height: 130px;
    width: 100%;
    margin-bottom: 30px;
    // background: pink;
    .filtrate_filer {
      height: 46px;
      width: 1040px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 16px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 46px;
      padding-left: 14px;
    }

    .el-input__inner {
      // height: 28px;
    }
    .el-input__icon {
      line-height: 28px;
    }
  }
  .form-title {
    height: 46px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }

    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }
}

.brand-page {
  background: #f5f5f5;
  color: #333;
  min-height: 1000px;
  .claify {
    width: 4px;
    height: 16px;
    background: rgba(52, 152, 219, 1);
    position: absolute;
    top: 17px;
    left: -10px;
  }

  .cover {
    width: 50px;
    display: block;
    margin: 0 auto;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    position: relative;
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
  }
}
</style>

